import mammoth from 'mammoth';

export const SUPPORTED_EXTENSIONS = ['.txt', '.md', '.docx'] as const;

export class UnsupportedFileError extends Error {
  constructor(public readonly fileName: string) {
    super(`Неподдерживаемый тип файла: ${fileName}`);
    this.name = 'UnsupportedFileError';
  }
}

const extensionOf = (name: string): string => {
  const dot = name.lastIndexOf('.');
  return dot === -1 ? '' : name.slice(dot).toLowerCase();
};

/** Читает File как текст через FileReader (работает в браузере и jsdom). */
const readAsText = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file, 'utf-8');
  });

/** Читает File как ArrayBuffer через FileReader (работает в браузере и jsdom). */
const readAsArrayBuffer = (file: File): Promise<ArrayBuffer> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(file);
  });

/** Извлекает текст из File. txt/md — нативно, docx — через mammoth. */
export const fileToText = async (file: File): Promise<string> => {
  const ext = extensionOf(file.name);

  if (ext === '.txt' || ext === '.md') {
    return readAsText(file);
  }

  if (ext === '.docx') {
    const arrayBuffer = await readAsArrayBuffer(file);
    const { value } = await mammoth.extractRawText({ arrayBuffer });
    return value;
  }

  throw new UnsupportedFileError(file.name);
};
